export default __webpack_public_path__ + "static/media/user-status-icon-grey.af141284.svg";